import React from "react";
import CommonTable from "../../../components/CommonTable";
import { TablePagination } from "@mui/material";
import { CategoryRow, Table } from "../settingInterface";

const headCells: Table<CategoryRow>[] = [
    { id: "S.No", label: "S.No", numeric: false, sorting: false },
    { id: "CategoryName", label: "Category", numeric: false },
    { id: "secondName", label: "SecondName", numeric: false },
    { id: "product_count", label: "No. of Products", numeric: true },
];

type Props = {
    data: CategoryRow[];
    totalRecords: number;
    page: number;
    rowsPerPage: number;
    showDeleted: boolean;
    onDelete: (ids: (string | number)[]) => void;
    onEdit: (id: string | number) => void;
    onPageChange: (_: any, page: number) => void;
    onRowsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSort: (data: { field: string; orderby: string }) => void;
};

const CategoryTable: React.FC<Props> = ({ data, totalRecords, page, rowsPerPage, showDeleted, onDelete, onEdit, onPageChange, onRowsChange, onSort }) => (
    <div className="mx-1 h-fit w-[99%] flex justify-center bg-white rounded-lg shadow-sm">
        <div className="w-full flex flex-col items-center">
            <CommonTable<CategoryRow>
                data={data} headCells={headCells} title=""
                onDeleteSelected={onDelete} onEditSelected={onEdit}
                selectable={false} Action={!showDeleted}
                pagenation={false} pageSize={rowsPerPage}
                shortByTable={false} OrderType={onSort}
            />
            <div className="w-[95%] bg-white border rounded-b-md -mt-1 mb-4">
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]} component="div"
                    count={totalRecords} rowsPerPage={rowsPerPage}
                    page={page} onPageChange={onPageChange} onRowsPerPageChange={onRowsChange}
                />
            </div>
        </div>
    </div>
);

export default CategoryTable;